<template>
  <ul
    class="cls-list"
    ref="wrapper"
  >
    <li
      class="cls-list-row"
      v-for="(row) in dataSource"
      :key="row.index"
    >
      <div
        class="cls-card-one"
        v-for="(item,index) in row"
        :key="index"
      >
        <BusCard
          :card_item="item"
          :eventId="eventId"
          :hasZongjia="hasZongjia"
          :clstagName='clstagName'
          :pageId="pageId"
          :channel="channel"
        />
      </div>
      <div
        class="cls-card-one"
        v-if="row.length===1"
      ></div>
    </li>
    <li
      ref="clsBottom"
      class="cls-scroll-bottom"
    >
      <NoMoreData :hasMoreData="hasMoreData"></NoMoreData>
    </li>
  </ul>
</template>

<script>
import BusCard from '@/buscomponents/BusCard.vue';
import NoMoreData from '@/buscomponents/NoMoreData.vue';
import { chunk } from 'lodash';
// import detectPrefixes from '../util/detectPrefixes';
export default {
  name: 'BusCardList',
  components: { BusCard, NoMoreData },
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    hasMoreData: {
      type: Boolean,
      default: true
    },
    eventId: {
      type: String,
      default: ''
    },
    pageId: {
      type: String
    },
    isCreatedLoadData: {
      type: Boolean,
      default: false
    },
    preLoad: {
      type: Number,
      default: 1.2
    },
    preLoadTop: {
      type: Number,
      default: 0
    },
    hasZongjia: {
      type: Boolean,
      default: false
    },
    clstagName: {
      type: String,
      default: '8530052_index_like'
    },
    channel: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      dataSource: []
    };
  },
  methods: {
    updateData() {
      this.dataSource = chunk(this.data, 2);
    },
    getRect() {
      if (this.$refs && this.$refs.clsBottom) {
        this.rect = this.$refs.clsBottom.getBoundingClientRect();
      } else {
        this.rect = null;
      }
    },
    checkInView() {
      this.getRect();
      if (this.rect) {
        return this.rect.top < window.innerHeight * this.preLoad && this.rect.bottom > this.preLoadTop && (this.rect.left < window.innerWidth * this.preLoad && this.rect.right > 0);
      } else {
        return false;
      }
    }
  },
  created() {
    if (this.isCreatedLoadData) {
      this.updateData();
    }

    let lock = false;
    const update = () => {
      if (this.checkInView() && !lock) {
        lock = true;

        const stt = setTimeout(() => {
          clearTimeout(stt);
          lock = false;
        }, 150);
        this.$emit('onMoreElementInView');
      }
    };

    $(document)
      .on('scroll', () => {
        update('scroll');
      })
      .on('touchstart', () => {
        update('touchstart');
      })
      .on('touchmove', () => {
        update('touchmove');
      })
      .on('touchend', () => {
        update('touchend');
      });
  },
  watch: {
    // 监听数据的变化，延时refreshDelay时间后调用refresh方法重新计算，保证滚动效果正常
    data() {
      this.updateData();
    }
  },
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/scss/mixin.scss';

.cls-list {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  white-space: normal;
  margin-top: $rem20;
}

.cls-list-row {
  width: 100%;
  display: flex;
  flex-direction: row;
  /* display: -webkit-inline-box; */
  // box-shadow: -3px 3px 6px 0 rgba(38, 50, 71, 1);
}

.cls-card-one {
  display: flex;
  flex: 1;
  margin: 0 $rem20 $rem40;
  width: 50%;
}

.cls-scroll-bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: $rem70;
  // border-top: 1px solid #eee;
  background: #ffffff;
  color: #999;
  font-size: $rem24;
  margin-bottom: $rem100;
  display: -webkit-inline-box !important;
}
</style>
